import Map from '@App/components/Map/Map';

import './home.css';

function Home() {
  return (
    <div className="home">
      <Map />
    </div>
  );
}

export default Home;
